<template>
  <div>
    <div class="row">
      <div class="col-xl-12">
        <div class="card card-custom gutter-b">
          <!--Begin::Body-->
          <div class="card-body">
            <div class="d-flex">
              <!--begin::Pic-->
              <div class="flex-shrink-0 mr-7">
                <div
                  class="symbol symbol-50 symbol-lg-120 symbol-light-primary"
                >
                  <span class="font-size-h3 symbol-label font-weight-boldest">{{
                    acronym(pharmacy.name)
                  }}</span>
                  <i v-if="pharmacy.isOpen" class="symbol-badge bg-success"></i>
                  <i v-if="!pharmacy.isOpen" class="symbol-badge bg-danger"></i>
                </div>
              </div>
              <!--end::Pic-->
              <!--begin: Info-->
              <div class="flex-grow-1">
                <!--begin::Title-->
                <div
                  class="d-flex align-items-center justify-content-between flex-wrap"
                >
                  <!--begin::User-->
                  <div class="mr-3">
                    <div class="d-flex align-items-center mr-3">
                      <!--begin::Name-->
                      <a
                        class="d-flex align-items-center text-dark text-hover-primary font-size-h5 font-weight-bold mr-3"
                        >{{ pharmacy.name }}</a
                      >
                      <!--end::Name-->
                      <span v-if="pharmacy.isOpen"
                        class="label label-light-success label-inline font-weight-bolder mr-1"
                        >En ligne</span
                      >
                      <span v-if="!pharmacy.isOpen"
                        class="label label-light-danger label-inline font-weight-bolder mr-1"
                        >Hors ligne</span
                      >
                    </div>
                    <!--begin::Contacts-->
                    <div class="d-flex flex-wrap my-2">
                      <a
                        class="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2"
                      >
                        <span
                          class="svg-icon svg-icon-md svg-icon-gray-500 mr-1"
                        >
                          <!--begin::Svg Icon | path:assets/media/svg/icons/Communication/Mail-notification.svg-->
                          <inline-svg
                            src="media/svg/icons/Communication/Mail-notification.svg"
                          />
                          <!--end::Svg Icon--> </span
                        >{{ pharmacy.email }}</a
                      >
                      <a
                        class="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2"
                      >
                        <span
                          class="svg-icon svg-icon-md svg-icon-gray-500 mr-1"
                        >
                          <!--begin::Svg Icon | path:assets/media/svg/icons/Communication/Mail-notification.svg-->
                          <i class="fas fa-map-marker-alt"></i>
                          <!--end::Svg Icon--> </span
                        >{{ pharmacy.address }}</a
                      >
                    </div>
                    <div class="d-flex flex-wrap my-2">
                      <a
                        class="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2"
                      >
                        <span
                          class="svg-icon svg-icon-md svg-icon-gray-500 mr-1"
                        >
                          <!--begin::Svg Icon | path:assets/media/svg/icons/Communication/Mail-notification.svg-->
                          <i class="fas fa-map"></i>
                          <!--end::Svg Icon--> </span
                        >{{ pharmacy.city }}, {{ pharmacy.department }}</a
                      >
                      <a
                        class="text-muted text-hover-primary font-weight-bold mr-lg-8 mr-5 mb-lg-0 mb-2"
                      >
                        <span
                          class="svg-icon svg-icon-md svg-icon-gray-500 mr-1"
                        >
                          <!--begin::Svg Icon | path:assets/media/svg/icons/Communication/Mail-notification.svg-->
                          <i class="fas fa-phone"></i>
                          <!--end::Svg Icon--> </span
                        >{{ pharmacy.phone }}</a
                      >
                    </div>
                    <!--end::Contacts-->
                  </div>
                  <!--begin::User-->
                </div>
                <!--end::Title-->
                <!--begin::Content-->
                <div
                  class="d-flex align-items-center flex-wrap justify-content-between"
                >
                  <!--begin::Description-->
                  <div class="flex-grow-1 text-muted-50 py-2 py-lg-2 mr-5">
                    {{ pharmacy.description }}
                  </div>
                  <!--end::Description-->
                  <!--begin::Progress-->
                  <!-- <div class="d-flex mt-4 mt-sm-0">
                    <span class="font-weight-bold mr-4">Progress</span>
                    <div
                      class="progress progress-xs mt-2 mb-2 flex-shrink-0 w-150px w-xl-500px"
                    >
                      <div
                        class="progress-bar bg-success"
                        role="progressbar"
                        style="width: 63%"
                        aria-valuenow="50"
                        aria-valuemin="0"
                        aria-valuemax="100"
                      ></div>
                    </div>
                    <span class="font-weight-bolder text-dark ml-4">78%</span>
                  </div> -->
                  <!--end::Progress-->
                </div>
                <!--end::Content-->
              </div>
              <!--end::Info-->
            </div>
          </div>
          <!--end::Body-->
        </div>
        <!--begin::Base Table Widget 7-->
        <div class="card card-custom gutter-b">
          <div class="card-header">
            <h3 class="card-title">Informations</h3>
            <div class="card-toolbar"></div>
          </div>
          <!--begin::Form-->
          <form class="form">
            <div class="card-body">
              <div class="form-group row">
                <label class="col-3 col-form-label">Disponibilité</label>
                <div class="col-4">
                  <span
                    class="switch switch-outline switch-icon switch-success"
                  >
                    <label>
                      <input type="checkbox"  name="select"  v-model="pharmacy.isOpen"/>
                      <span></span>
                    </label>
                  </span>
                </div>
              </div>
              <div class="form-group row">
                <div class="col-lg-4">
                  <label>Raison sociale</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="raison sociale"
                    v-model="pharmacy.name"
                  />
                </div>
                <div class="col-lg-4">
                  <label>Email</label>
                  <input
                    type="email"
                    class="form-control"
                    placeholder="email"
                    v-model="pharmacy.email"
                  />
                </div>
                <div class="col-lg-4">
                  <label>Téléphone</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Téléphone"
                    v-model="pharmacy.phone"
                  />
                </div>
              </div>
              <div class="form-group row">
                <div class="col-lg-4">
                  <label>Wilaya</label>
                  <select
                    class="form-control"
                    v-model="pharmacy.departmentId"
                    @change="selectDepartment()"
                  >
                    <option
                      v-for="department in departments"
                      v-bind:value="department.id"
                      v-bind:key="department.id"
                    >
                      {{ department.name }}
                    </option>
                  </select>
                </div>
                <div class="col-lg-4">
                  <label>Commune</label>
                  <select class="form-control" v-model="pharmacy.cityId">
                    <option
                      v-for="city in cities"
                      v-bind:value="city.id"
                      v-bind:key="city.id"
                    >
                      {{ city.name }}
                    </option>
                  </select>
                </div>
                <div class="col-lg-4">
                  <label>Adresse</label>
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Adresse"
                      v-model="pharmacy.address"
                    />
                    <div class="input-group-append">
                      <span class="input-group-text">
                        <i class="la la-map-marker"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="form-group row">
                <!-- <div class="col-lg-6">
                  <label>Description </label>
                  <textarea
                    class="form-control"
                    rows="3"
                    v-model="pharmacy.description"
                  ></textarea>
                </div> -->
                <div class="col-lg-6">
                  <label>Position GPS </label>
                  <l-map
                    @ready="intMap()"
                    ref="myMap"
                    style="height: 350px"
                    :zoom="zoom"
                    :center="center"
                    @click="addMarker"
                  >
                    <l-tile-layer :url="url"></l-tile-layer>
                    <l-marker
                      v-if="markerLatLng"
                      :lat-lng="markerLatLng"
                      @click="removeMarker()"
                    >
                    </l-marker>
                  </l-map>
                </div>
              </div>
            </div>

            <div class="card-footer">
              <div class="row">
                <div class="col-lg-4"></div>
                <div class="col-lg-4 text-center">
                  <button
                    type="button"
                    class="btn btn-success mr-2"
                    @click="editPharmacy()"
                  >
                    <i class="fas fa-save"></i>
                    Sauvegarder
                  </button>
                </div>
              </div>
            </div>
          </form>
          <!--end::Form-->
        </div>
        <!--end::Base Table Widget 7-->
      </div>
    </div>
  </div>
</template>

<style>
.leaflet-geosearch-bar {
  position: relative;
  display: block;
  height: auto;
  width: 400px;
  max-width: calc(100% - 120px);
  margin: 10px auto 0;
  cursor: auto;
  z-index: 1;
}
</style>

<script>
import { mapGetters } from "vuex";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";

import L from "leaflet";
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import { OpenStreetMapProvider, GeoSearchControl } from "leaflet-geosearch";

import DepartmentsService from "../../../services/departments.service";
import PharmaciesService from "../../../services/pharmacies.service";

export default {
  name: "pharmacy",
  components: {
    LMap,
    LTileLayer,
    LMarker,
  },
  data() {
    return {
      map: {},
      pharmacy: {},
      departments: [],
      cities: [],
      zoom: 10,
      center: L.latLng(28.0339, 1.6596),
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      markerLatLng: null,
    };
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Pharmacie", route: "pharmacy" },
      { title: "Ma phrmacie" },
    ]);

    this.getPharmacy();
  },
  methods: {
    intMap: function () {
      this.map = this.$refs.myMap.mapObject;

      const provider = new OpenStreetMapProvider({
        params: { countrycodes: "dz" },
      });
      const searchControl = new GeoSearchControl({
        provider: provider,
        style: "bar",
        showMarker: false,
        autoClose: true,
        searchLabel: "Recherche",
      });

      this.map.addControl(searchControl);
    },
    initPharmacyPosition: function (pharmacy) {
      if (pharmacy.latitude && pharmacy.longitude) {
        var latlng = L.latLng(pharmacy.latitude, pharmacy.longitude);
        this.markerLatLng = latlng;

        this.map.setView(latlng, 16, {
          animate: true,
        });
      }
    },
    getPharmacy: function () {
      PharmaciesService.getPharmacy(this.currentPharmacy.guid).then(
        (result) => {
          this.pharmacy = result.data;
          this.getDepartments();
          this.initPharmacyPosition(this.pharmacy);
        }
      );
    },
    getDepartments: function () {
      DepartmentsService.getDepartments().then((result) => {
        this.departments = result.data;
        this.getDepartmentCities();
      });
    },
    getDepartmentCities() {
      var department = this.departments.find((item) => {
        return item.id == this.pharmacy.departmentId;
      });
      if (department) {
        this.cities = department.cities;
      }
    },
    selectDepartment() {
      var department = this.departments.find((item) => {
        return item.id == this.pharmacy.departmentId;
      });

      if (department) this.cities = department.cities;
      else this.cities = [];
      this.pharmacy.cityId = null;
    },
    removeMarker() {
      this.markerLatLng = null;
    },
    addMarker(event) {
      this.markerLatLng = event.latlng;
    },
    acronym: function (str) {
      if (str) {
        var matches = str.match(/\b(\w)/g);
        var acronym = matches.join("");
        return acronym;
      }
      return "";
    },
    editPharmacy: function () {
      this.pharmacy.latitude = this.markerLatLng?.lat;
      this.pharmacy.longitude = this.markerLatLng?.lng;
      PharmaciesService.editPharmacy(this.pharmacy).then(() => {
        this.getPharmacy();
      });
    },
  },
  computed: {
    ...mapGetters(["currentPharmacy"]),
  },
};
</script>
